import { Package } from 'pages/newSubscription/models';

const UNKNOWN_ERROR_MESSAGE = 'Sorry, something went wrong. Please try again.';

export class FreeTrialSubscriptionParser {
  public static getPageHeaderInfo = (step: number) => {
    switch (step) {
      case 1:
        return {
          title: 'Choose your trial package',
          nextStep: 'School details',
        };
      case 2:
        return {
          title: 'Enter school details',
          nextStep: 'Profile details',
        };
      case 3:
        return { title: 'Enter profile details', nextStep: '' };
      default:
        return { title: '', nextStep: '' };
    }
  };

  public static buildSubmitFreeTrialPackagesPayload = (
    registrationToken: string,
    generalPackagesId: number,
    subjectsIds: any
  ) => {
    return { 
      registrationToken,
      generalPackagesId: generalPackagesId,
      subjectsIds: subjectsIds,
    };
  };

  public static parseError = (errors: any) => {
    let error: string;
    switch (errors[0].messageCode) {
      case 'Missing_PromoCode':
        error = 'Promo code is missing';
        break;
      case 'Invalid_PromoCode':
        error = 'Invalid promo code';
        break;
      default:
        error = UNKNOWN_ERROR_MESSAGE;
    }
    return error;
  };
}
